import { useUnifyAdminStore } from '../../AdminStore';
import * as StyledComponents from '../StyledComponents';
import get from 'lodash/get';
import { t } from 'i18next';

export const OutageCustomMultiTargetEditor = ({readOnlyMode}: any): JSX.Element => {

    const sideSheetData = useUnifyAdminStore(
        (state) => state.productOutageSideSheetData
    );
    const updateProductOutageSideSheetData= useUnifyAdminStore(
        (state) => state.updateProductOutageSideSheetData
    );

    const ontargetEnterpriseChange = (e: any) => {
        updateProductOutageSideSheetData({
            fieldName: 'targetEnterprises',
            value: e.target.value,
        });
        updateProductOutageSideSheetData({
            fieldName: 'uploadedEnterprises',
            value: e.target.value,
          });
    };

  const ontargetCNumbersChange = (e: any) => {
    updateProductOutageSideSheetData({
      fieldName: 'targetCNumbers',
      value: e.target.value,
    });
    updateProductOutageSideSheetData({
      fieldName: 'uploadedCNumbers',
      value: e.target.value,
    });
  };

    const ontargetStoresChange = (e: any) => {
        updateProductOutageSideSheetData({
            fieldName: 'targetStores',
            value: e.target.value,
        });
        updateProductOutageSideSheetData({
            fieldName: 'uploadedStores',
            value: e.target.value,
        });
    };

  return (
   <div style={{width: '90%', paddingTop:'15px'}}>
     <StyledComponents.StyledInput
        dataTestId={`target-enterprise-desc-input`}
        errorMessage="Error message"
        id={`target-enterprise-name-input`}
        inputDivider="left"
        label={t('productAlerts.targetEnterprises')}
        name="targetEnterprises"
        placeholder={'Eg. E123221,E343212'}
        onChange={ontargetEnterpriseChange}
        value={get(sideSheetData, 'targetEnterprises', '')}
        hasCharacterCount={true}
        maxLength={40000}
        isDisabled={readOnlyMode}
      /> 
      <StyledComponents.StyledInput
        dataTestId={`target-cnumbers-name-input`}
        errorMessage="Error message"
        id={`target-cnumbers-name-input`}
        inputDivider="left"
        label={t('productAlerts.targetCNumbers')}
        name="targetCNumbers"
        placeholder={'Eg. C123221,C343212'}
        onChange={ontargetCNumbersChange}
        value={get(sideSheetData, 'targetCNumbers', '')}
        hasCharacterCount={true}
        maxLength={40000}
        isDisabled={readOnlyMode}
      /> 
    <StyledComponents.StyledInput
      dataTestId={`target-stores-name-input`}
      errorMessage="Error message"
      id={`target-stores-name-input`}
      inputDivider="left"
      label={t('productAlerts.targetStores')}
      name="targetStores"
      placeholder={'Eg. S123221,S343212'}
      onChange={ontargetStoresChange}
      value={get(sideSheetData, 'targetStores', '')}
      hasCharacterCount={true}
      maxLength={40000}
      isDisabled={readOnlyMode}
    /> 
   </div>
  );
};